import axios from "axios";
import { controlApiTarget, controlCsrfHeader, validControlCsrf } from "./controlCsrf";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let sessionCsrf = null;
let inFlight = 0;

// Requests the user did not trigger (session checks) are marked so they never count as activity.
export const BACKGROUND = { headers: { "X-Visibilis-Background": "1" } };
const AUTH_FLOW = /^\/auth\/(login|verify-2fa|2fa\/|password|refresh)/;

// Idle = no API request pending (used to decide that a page has finished loading).
export const apiIdle = () => inFlight === 0;
const settle = () => { inFlight = Math.max(0, inFlight - 1); };
api.interceptors.request.use((config) => { inFlight += 1; return config; });
api.interceptors.response.use((r) => { settle(); return r; }, (e) => { settle(); return Promise.reject(e); });

api.interceptors.response.use((response) => {
  if (typeof window !== "undefined" &&
      controlApiTarget(api.getUri(response.config), API, window.location.href)) {
    if (validControlCsrf(response.data?.csrf_token)) sessionCsrf = response.data.csrf_token;
    const uri = new URL(api.getUri(response.config), window.location.href);
    if (uri.pathname === new URL(API, window.location.href).pathname + "/auth/logout")
      sessionCsrf = null;
    const left = response.headers?.["x-session-remaining"];
    if (left !== undefined && left !== null)
      window.dispatchEvent(new CustomEvent("control:session-clock", { detail: {
        remaining: Number(left), idle: Number(response.headers["x-session-idle-remaining"]),
        background: response.config.headers?.["X-Visibilis-Background"] === "1" } }));
  }
  return response;
}, (error) => {
  const url = error.config?.url || "";
  if (error.response?.status === 401 && !AUTH_FLOW.test(url) && typeof window !== "undefined")
    window.dispatchEvent(new CustomEvent("control:session-expired", {
      detail: { reason: error.response.headers?.["x-session-expired"] || null } }));
  return Promise.reject(error);
});

api.interceptors.request.use((config) => {
  if (typeof window === "undefined" || typeof document === "undefined") return config;
  const token = controlCsrfHeader(config.method, api.getUri(config), API,
                                 window.location.href, document.cookie, sessionCsrf);
  // Strip an explicitly supplied token on an untrusted URL as well.
  const headers = config.headers || {};
  if (typeof headers.delete === "function") headers.delete("X-Control-CSRF");
  else Object.keys(headers).filter((key) => key.toLowerCase() === "x-control-csrf")
    .forEach((key) => delete headers[key]);
  if (token) headers["X-Control-CSRF"] = token;
  config.headers = headers;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

